module.exports = __webpack_public_path__ + "5a179c6da79458d539d9da34c101058f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox-office365.png
// module id = 164
// module chunks = 0 1